import { ui, state } from "../../interfaces/interfaces";
import AppointmentDate from "@utils/appointmentDate";
// import { calculateCostBeforeVAT, processScript, validateTab } from "@utils/general";
import { processScript, validateTab } from "@utils/general";
import subscriptions from "@services/subscriptions/instance";
import { serviceManager } from "@services/workers";
import { RightioWBSAPIModelsSPSpUsersGetStatisticsResult } from "@utils/apis/wbs/model";
import { validateBookingPaymentMethod } from "@utils/validation";

export const tempProcessor = (action: { payload: { name: string; value: any } }, next: any) => {
  switch (action.payload.name) {
    case "TimeRequirementType":
      state.JobTimeRequirementTypeId = action.payload.value?.timeRequirementTypeId ?? 0;
      return next(action);

    case "BookingPaymentMethodCompanyRegistrationAccepted":
      validateBookingPaymentMethod("BookingPaymentMethod", "CompanyRegistration", action.payload.value);
      return next(action);

    case "BookingPaymentMethodCompanyRegistrationValid":
      return next(action);

    case "ProblemAddressCoverage":
      if (!action.payload.value) {
        state.ProblemCoverageValid = action.payload.value;
      } else {
        state.ProblemCoverageValid = action.payload.value;
      }
      return next(action);

    case "IsAGoBack":
      action.payload.value && (state.CallTypeId = 3); // 3 = Go Back
      subscriptions.publish("CallTypeId", 3);
      validateTab("BookingPayment");
      state.Step3_3Valid = action.payload.value;
      return next(action);

    case "IsAQuote":
      state.CallTypeId = action.payload.value ? 2 : 1; // 1 = Normal, 2 = Quote, 3 = Go Back
      subscriptions.publish("CallTypeId", action.payload.value ? 2 : 1);
      validateTab("BookingPayment");
      state.Step3_3Valid = action.payload.value;
      return next(action);

    case "Emergency":
      if (action.payload.value) {
        const timeRequirementType = AppointmentDate.getTimeRequirementType(action.payload.value, new Date());

        // state.JobTimeRequirementTypeId = timeRequirementType.timeRequirementTypeId;
        state.TimeRequirementType = timeRequirementType;
      }
      return next(action);

    case "CallCampaign":
      if (action.payload.value !== null)
        ui.CallAlert = {
          from: ui.CallAlert?.from ?? "",
          to: ui.CallAlert?.to ?? "",
          campaign: ui.CallAlert?.campaign ?? "",
          severity: "success",
          complete: true,
          show: true,
        };
      return next(action);

    case "CallNotes":
      if (action.payload.value) action.payload.value = action.payload.value.trim();
      return next(action);

    case "UsersStatistics":
    case "UsersStatisticsYesterday":
      if (action.payload.value && action.payload.value?.length > 0) {
        const data: any = {
          userId: -1,
          name: "Total",
          departmentId: 0,
          totalJobs: action.payload.value.reduce(
            (acc: number, cur: Required<RightioWBSAPIModelsSPSpUsersGetStatisticsResult>) => acc + cur.totalJobs,
            0
          ),
          callsForHitRate: action.payload.value.reduce(
            (acc: number, cur: Required<RightioWBSAPIModelsSPSpUsersGetStatisticsResult>) => acc + cur.callsForHitRate,
            0
          ),
          opportunities: action.payload.value.reduce(
            (acc: number, cur: Required<RightioWBSAPIModelsSPSpUsersGetStatisticsResult>) => acc + cur.opportunities,
            0
          ),
          bookings: action.payload.value.reduce(
            (acc: number, cur: Required<RightioWBSAPIModelsSPSpUsersGetStatisticsResult>) => acc + cur.bookings,
            0
          ),
          emailCollected: action.payload.value.reduce(
            (acc: number, cur: Required<RightioWBSAPIModelsSPSpUsersGetStatisticsResult>) => acc + cur.emailCollected,
            0
          ),
          cardDetailsCollected: action.payload.value.reduce(
            (acc: number, cur: Required<RightioWBSAPIModelsSPSpUsersGetStatisticsResult>) => acc + cur.cardDetailsCollected,
            0
          ),
          noiseCalls: action.payload.value.reduce(
            (acc: number, cur: Required<RightioWBSAPIModelsSPSpUsersGetStatisticsResult>) => acc + cur.noiseCalls,
            0
          ),
          fails: action.payload.value.reduce(
            (acc: number, cur: Required<RightioWBSAPIModelsSPSpUsersGetStatisticsResult>) => acc + cur.fails,
            0
          ),
          jobsReduced: action.payload.value.reduce(
            (acc: number, cur: Required<RightioWBSAPIModelsSPSpUsersGetStatisticsResult>) => acc + cur.jobsReduced,
            0
          ),
          quotes: action.payload.value.reduce(
            (acc: number, cur: Required<RightioWBSAPIModelsSPSpUsersGetStatisticsResult>) => acc + cur.quotes,
            0
          ),
          goBacks: action.payload.value.reduce(
            (acc: number, cur: Required<RightioWBSAPIModelsSPSpUsersGetStatisticsResult>) => acc + cur.goBacks,
            0
          ),
          carePlans: action.payload.value.reduce(
            (acc: number, cur: Required<RightioWBSAPIModelsSPSpUsersGetStatisticsResult>) => acc + cur.carePlans,
            0
          ),
        };
        data.bookingRate = (data.bookings / (data.bookings + data.fails)) * 100 || 0;
        data.hitRate = data.callsForHitRate ? (data.bookings / data.callsForHitRate) * 100 : 0;
        data.cardRate = data.cardDetailsCollected ? (data.bookings / data.cardDetailsCollected) * 100 : 0;
        data.emailRate = data.emailCollected ? (data.bookings / data.emailCollected) * 100 : 0;
        data.carePlanRate = data.carePlans ? (data.bookings / data.carePlans) * 100 : 0;
        data.opportunityRate = data.opportunities ? (data.bookings / data.opportunities) * 100 : 0;
        data.noiseRate = data.noiseCalls ? (data.bookings / data.noiseCalls) * 100 : 0;
        // data.abandonRate = (data.fails / data.bookings) * 100;
        data.reducedRate = data.jobsReduced ? (data.bookings / data.jobsReduced) * 100 : 0;

        // add new data to response array
        action.payload.value.push(data);
      }
      return next(action);

    case "Charge":
      return next(action);

    case "Discount":
      return next(action);

    case "ChargeRateAdj":
      ui.RatesDiscount = action.payload.value;
      return next(action);

    case "Script":
      if (action.payload.value) {
        const jobScript = processScript(action.payload.value.jobScript);
        action.payload.value = { ...action.payload.value, jobScript };
        ui.RateText = jobScript;
      }
      return next(action);

    case "JobId":
      if (action.payload.value) {
        ui.BookingId = action.payload.value;
        serviceManager.sendMessageToWorker({
          serviceName: "LOG_SYNC",
          serviceData: {
            origin: "MAIN_THREAD",
            command: "SET_JOB_ID",
            payload: Number(action.payload.value),
          },
        });
      }
      return next(action);

    default:
      return next(action);
  }
};
